"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EcomFilter = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const useCategories_1 = require("../lib/hooks/useCategories");
const _1 = require(".");
function EcomFilter({ mapper, menuLink, spacing, className, additional, }) {
    var _a;
    const { t } = (0, app_1.useTranslation)();
    const { categories, loading } = (0, useCategories_1.useCategories)();
    const filterDefinitions = [
        {
            title: t('store.label.allCategories'),
            path: '/',
            values: [],
        },
        ...(mapper
            ? mapper(categories)
            : (_a = categories === null || categories === void 0 ? void 0 : categories.map(({ slug, title }) => ({
                title,
                path: slug,
                value: slug,
                values: [],
            }))) !== null && _a !== void 0 ? _a : []),
        ...(additional !== null && additional !== void 0 ? additional : [
            {
                title: t('store.label.sale'),
                path: 'sale',
                values: [],
            },
        ]),
    ];
    return ((0, jsx_runtime_1.jsx)(_1.EcomFilterView, { menuLink: menuLink, filterDefinitions: filterDefinitions, loading: loading, spacing: spacing, className: className }));
}
exports.EcomFilter = EcomFilter;
